import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '~shared/api/query-keys';

import { getPaymentRunReviewDetailAPI, getPaymentRunReviewReportAPI } from './api';
import type {
  GetPaymentRunReviewDetailParams,
  GetPaymentRunReviewParams,
} from './types';

export const useGetPaymentRunReviewReport = (
  params: GetPaymentRunReviewParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: QUERY_KEYS.PAYMENT_RUN_REVIEW(params),
    queryFn: () => getPaymentRunReviewReportAPI(params),
    enabled:
      options?.enabled !== false &&
      !!params.startDate &&
      !!params.endDate,
  });
};

export const useGetPaymentRunReviewDetail = (
  params: GetPaymentRunReviewDetailParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: QUERY_KEYS.PAYMENT_RUN_REVIEW_DETAIL(
      params.invoiceId,
      params.startDate,
      params.endDate,
    ),
    queryFn: async () => {
      const id = params.invoiceId;
      if (!id) {
        throw new Error('Missing invoice id');
      }
      return getPaymentRunReviewDetailAPI({
        invoiceId: id,
        startDate: params.startDate,
        endDate: params.endDate,
      });
    },
    enabled:
      (options?.enabled !== false) &&
      !!params.invoiceId &&
      !!params.startDate &&
      !!params.endDate,
  });
};
